import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * OAuth Callback Page
 * This page handles the redirect from OAuth providers and communicates
 * the authorization code back to the parent window.
 */
export default function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Extract OAuth parameters from URL
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    // Determine provider from state or URL
    // The state parameter contains provider info set during auth initiation
    const provider = determineProvider();

    // Send message to parent window (the main app)
    if (window.opener) {
      window.opener.postMessage({
        type: 'oauth_callback',
        provider,
        code,
        state,
        error: error || errorDescription,
      }, window.location.origin);

      // Close popup after sending message
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      // If no opener (direct navigation), redirect to social connections page
      window.location.href = '/social-connections';
    }
  }, [searchParams]);

  // Determine which provider based on URL patterns
  function determineProvider() {
    const url = window.location.href;
    if (url.includes('instagram') || url.includes('facebook') || url.includes('meta')) {
      return 'meta';
    }
    if (url.includes('youtube') || url.includes('google')) {
      return 'youtube';
    }
    if (url.includes('tiktok')) {
      return 'tiktok';
    }
    if (url.includes('linkedin')) {
      return 'linkedin';
    }
    if (url.includes('pinterest')) {
      return 'pinterest';
    }
    // Default - try to get from state
    return searchParams.get('provider') || 'unknown';
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50">
      <div className="text-center p-8 bg-white rounded-2xl shadow-xl max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-500 border-t-transparent mx-auto mb-4" />
        <h2 className="text-xl font-serif text-obsidian mb-2">Completing Connection...</h2>
        <p className="text-muted-foreground text-sm">
          Please wait while we securely connect your account.
        </p>
        <p className="text-xs text-muted-foreground mt-4">
          This window will close automatically.
        </p>
      </div>
    </div>
  );
}
